import { render } from "./InsuranceCompanyDetail.vue?vue&type=template&id=03ae8c06"
import script from "./InsuranceCompanyDetail.vue?vue&type=script&lang=js"
export * from "./InsuranceCompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__